module.exports = __webpack_public_path__ + "static/img/potenciometro_100k-1.aaad754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/potenciometro_100k-1.svg
// module id = nZcE
// module chunks = 0